import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { slugify } from '../../shared/slugify';
import './ArticleCard.scss';
import { SmartLink } from '../SmartLink/SmartLink';

export interface ArticleCardProps {
    title: string;
    category: string;
    buttonLink: string;
    categories: string[];
    date: Date;
    image: IGatsbyImageData;
    altText: string;
}

export const ArticleCard = (props: ArticleCardProps) => {
    const { mediaHeroImage: placeholderImg } = useStaticQuery(graphql`
        query {
            mediaHeroImage(name: { eq: "article-image-placeholder" }) {
                field_media_image {
                    alt
                }
                relationships {
                    field_media_image {
                        localFile {
                            childImageSharp {
                                ...ImageConstrainedOneHalfSettings
                            }
                        }
                    }
                }
            }
        }
    `);

    let img = props.image;

    if (!img) {
        img = getImage(
            placeholderImg.relationships?.field_media_image?.localFile
        );
    }

    const title = props.title.replaceAll(`**`, ``);
    const id = `header-${slugify(title)}`;
    return (
        <li className="c--article-card">
            <SmartLink
                className={`article-card-inner`}
                href={props.buttonLink}
                title={`${title}`}
                aria-describedby={id}
            >
                <GatsbyImage image={img} alt={props.altText} />
                <h3 id={id} className="typestack-title-5">
                    {props.category && (
                        <span className="eyebrow">{props.category}</span>
                    )}
                    <span>{title}</span>
                </h3>
            </SmartLink>
        </li>
    );
};
